//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SPFResult, DkimResult } from './Enums';

export class SenderDiagnosticDisplayItem extends ItemBase {
    DomainName: string | null = null;
    IsPublicMailProvider: boolean = false;
    CanSendOnBehalfOf: boolean = false;
    SpfResult: SPFResult = SPFResult.Misconfigured;
    RecommendedSpfRecordName: string | null = null;
    RecommendedSpfRecordValue: string | null = null;
    ExistingSpfRecords: string[] = [];
    DkimResult: DkimResult = DkimResult.OK;
    RecommendedDkimRecordName: string | null = null;
    RecommendedDkimRecordValue: string | null = null;
    FromAddress: string | null = null;
    ReplyToAddress: string | null = null;

    constructor(initializer?: Partial<SenderDiagnosticDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SenderDiagnosticDisplayItem";
}
